import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { VerifyStatus } from "../../../models/Timesheet";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";

const TimesheetReportUS = ({ filter, groupName }: { filter: any, groupName: string | null }) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const [subTableData, setSubTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const [openSubModel, setOpenSubModel] = useState({ open: false, name: "", company: 0, pO_IDs: "" } as { open: boolean, name: string, company: number, pO_IDs: "" });
  const dt = useRef<any>(null);
  const toast = useRef<any>(null);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
  const DateFormat = loginObj.date_Format;

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Timesheets Report</h5>
    </div>
  );

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });

    const mappedFilter = {
      FromDate: filter?.fromDate,
      ToDate: filter?.ToDate,
      Company_ID: filter?.company_ID ?? null,
      Group_ID: filter?.company_Group_ID ?? null,
    };

    const response = await Fetch("Report_Timesheet/getTimesheetsAddedCount", "GET", null, `filter=${JSON.stringify(mappedFilter)}`, null);
    if (response) {
      const data: Array<any> = await response.json();
      setTableData({ tableData: data, loading: false });
    }
  };

  // const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  // const DateFormat = loginObj?.date_Format;

  const loadSubTable = async () => {
    console.log(1);
    setSubTableData({ tableData: subTableData.tableData, loading: true });
    const mappedFilter = {
      FromDate: filter.fromDate,
      ToDate: filter.ToDate,
      Type: openSubModel.name,
      PO_IDs: openSubModel.pO_IDs,
    };

    console.log(mappedFilter);

    const response = await Fetch("Report_Timesheet/getAddedTimesheetsDetails", "POST", mappedFilter, null, null);
    if (response) {
      const data: Array<any> = await response.json();
      setSubTableData({ tableData: data, loading: false });
    } else setSubTableData({ tableData: subTableData.tableData, loading: false });
  }

  useEffect(() => {
    loadTableData();
  }, [filter]);

  useEffect(() => {
    if (openSubModel.open) loadSubTable();
  }, [openSubModel]);

  const isGroupWise = filter?.company_Type === "Company Group Wise";

  const headerGroup = (
    <ColumnGroup>
      {/* First header row */}
      <Row>
        <Column header="SN" rowSpan={1} />
        <Column header="Company & Consultant#" headerStyle={{
          backgroundColor: "#bbd0fd",
          paddingLeft: "3%",
          fontWeight: "bolder"
        }} colSpan={2} />
        <Column header="Consultant Activities" headerStyle={{
          backgroundColor: "#a8f6b0",
          paddingLeft: "3%",
          fontWeight: "bolder"
        }} colSpan={2} />
        <Column header="Subvendor Activities" headerStyle={{
          backgroundColor: "#f9cb9c",
          paddingLeft: "3%",
          fontWeight: "bolder"
        }} colSpan={2} />
        <Column header="Inhouse Activities" headerStyle={{
          backgroundColor: "#fa9bf2",
          paddingLeft: "3%",
          fontWeight: "bolder"
        }} colSpan={2} />
        <Column header="Pending Summary" headerStyle={{
          backgroundColor: "#f9f497",
          paddingLeft: "8%",
          fontWeight: "bolder"
        }} colSpan={3} />
      </Row>

      {/* Second header row */}
      <Row>
        <Column header="" />

        <Column header="Company Name" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} />
        <Column header="Consultant#" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} />

        <Column header="Consultant#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />
        <Column header="Timesheet#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />

        <Column header="Consultant#" headerStyle={{
          backgroundColor: "#f9cb9c",
          textAlign: "center"
        }} />
        <Column header="Timesheet#" headerStyle={{
          backgroundColor: "#f9cb9c",
          textAlign: "center"
        }} />

        <Column header="Consultant#" headerStyle={{
          backgroundColor: "#fa9bf2",
          textAlign: "center"
        }} />
        <Column header="Timesheet#" headerStyle={{
          backgroundColor: "#fa9bf2",
          textAlign: "center"
        }} />

        <Column header="Consultant#" headerStyle={{
          backgroundColor: "#f9f497",
          textAlign: "center"
        }} />
        <Column header="Timesheet#" headerStyle={{
          backgroundColor: "#f9f497",
          textAlign: "center"
        }} />
        <Column header="Status" headerStyle={{
          backgroundColor: "#f9f497",
          textAlign: "center"
        }} />
      </Row>
    </ColumnGroup>
  );

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
      </React.Fragment>
    );
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" right={rightToolbarTemplate} />
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px", textAlign: "center" }}
        resizableColumns
        showGridlines
        columnResizeMode="expand"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        ref={dt}
        size="small"
        stripedRows
        scrollable
        scrollHeight="70vh"
        value={tableData.tableData}
        header={header}
        loading={tableData.loading}
        headerColumnGroup={headerGroup}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={() => <b>TOTAL</b>} />

        {isGroupWise ? <Column field="company_Name" header={`Company Name of ${groupName || ""}`} headerStyle={{ backgroundColor: "#dbeafe" }} bodyStyle={{ backgroundColor: "#dbeafe" }} footerStyle={{ backgroundColor: "#dbeafe" }} /> : <Column field="company_Name" header="Company" headerStyle={{ backgroundColor: "#dbeafe" }} bodyStyle={{ backgroundColor: "#dbeafe" }} footerStyle={{ backgroundColor: "#dbeafe" }} />}
        <Column field="consultantCount" header="Consultant#" headerStyle={{ backgroundColor: "#dbeafe" }} bodyStyle={{ backgroundColor: "#dbeafe" }} footerStyle={{ backgroundColor: "#dbeafe" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.consultantCount || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />

        <Column field="addedByConsultant" header="Consultant#" headerStyle={{ backgroundColor: "#c1fbc7" }} bodyStyle={{ backgroundColor: "#c1fbc7" }} footerStyle={{ backgroundColor: "#c1fbc7" }} body={(rowData: any, options: any) => <p><span>{rowData.total_Consultant_Added_By_Consultant}</span></p>} footer={() => {
          const consultantCount2 = tableData.tableData.reduce((sum, item) => sum + (item.total_Consultant_Added_By_Consultant || 0), 0);
          return <span className="font-bold">{consultantCount2}</span>;
        }} />
        <Column field="addedByConsultant" header="Timesheet#" headerStyle={{ backgroundColor: "#c1fbc7" }} bodyStyle={{ backgroundColor: "#c1fbc7" }} footerStyle={{ backgroundColor: "#c1fbc7" }} body={(rowData: any, options: any) => <p className={(rowData.addedByConsultant > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "2", company: rowData.company_ID, pO_IDs: rowData.pO_IDs })}>{rowData.addedByConsultant}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedByConsultant || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />

        <Column field="addedBySubVendor" header="Timesheet#" headerStyle={{ backgroundColor: "#fddcbb" }} bodyStyle={{ backgroundColor: "#fddcbb" }} footerStyle={{ backgroundColor: "#fddcbb" }} body={(rowData: any, options: any) => <p className={(rowData.addedBySubVendor > 0) ? "cursor-pointer text-cyan-700 underline" : ""}>{rowData.total_Consultant_Added_By_SubVendor}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.total_Consultant_Added_By_SubVendor || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="addedBySubVendor" header="Consultant#" headerStyle={{ backgroundColor: "#fddcbb" }} bodyStyle={{ backgroundColor: "#fddcbb" }} footerStyle={{ backgroundColor: "#fddcbb" }} body={(rowData: any, options: any) => <p className={(rowData.addedBySubVendor > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "3", company: rowData.company_ID, pO_IDs: rowData.pO_IDs })} ><span>{rowData.addedBySubVendor}</span></p>} footer={() => {
          const consultantCount2 = tableData.tableData.reduce((sum, item) => sum + (item.addedBySubVendor || 0), 0);
          return <span className="font-bold">{consultantCount2}</span>;
        }} />

        <Column field="addedByInHouse" header="Timesheet#" headerStyle={{ backgroundColor: "#fab7f4" }} bodyStyle={{ backgroundColor: "#fab7f4" }} footerStyle={{ backgroundColor: "#fab7f4" }} body={(rowData: any, options: any) => <p>{rowData.total_Consultant_Added_By_InHouse}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.total_Consultant_Added_By_InHouse || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="addedByInHouse" header="Consultant#" headerStyle={{ backgroundColor: "#fab7f4" }} bodyStyle={{ backgroundColor: "#fab7f4" }} footerStyle={{ backgroundColor: "#fab7f4" }} body={(rowData: any, options: any) => <p className={(rowData.addedByInHouse > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "1", company: rowData.company_ID, pO_IDs: rowData.pO_IDs })} ><span>{rowData.addedByInHouse}</span></p>} footer={() => {
          const consultantCount2 = tableData.tableData.reduce((sum, item) => sum + (item.addedByInHouse || 0), 0);
          return <span className="font-bold">{consultantCount2}</span>;
        }} />

        <Column field="no_Of_Consultants_Timesheet_Not_Added" header="Consultant#" headerStyle={{ backgroundColor: "#fdfabb" }} bodyStyle={{ backgroundColor: "#fdfabb" }} footerStyle={{ backgroundColor: "#fdfabb" }} body={(rowData: any, options: any) => <p>{rowData.no_Of_Consultants_Timesheet_Not_Added}</p>} footer={() => {
          const consultantCount2 = tableData.tableData.reduce((sum, item) => sum + (item.no_Of_Consultants_Timesheet_Not_Added || 0), 0);
          return <span className="font-bold">{consultantCount2}</span>;
        }} />
        <Column field="timesheetLeft" header="Timesheet#" headerStyle={{ backgroundColor: "#fdfabb" }} bodyStyle={{ backgroundColor: "#fdfabb" }} footerStyle={{ backgroundColor: "#fdfabb" }} body={(rowData: any, options: any) => <p>{(Number(rowData.no_Of_Timesheets_To_Be_Added || "0") - Number(rowData.totalAdded || "0")) > 0 ? (Number(rowData.no_Of_Timesheets_To_Be_Added || "0") - Number(rowData.totalAdded || "0")) : 0}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (Number(item.no_Of_Timesheets_To_Be_Added || "0") - Number(item.totalAdded || "0") || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="status" header="Status" headerStyle={{ backgroundColor: "#fdfabb" }} body={(rowData: any) => <p style={{ color: ((Number(rowData.no_Of_Timesheets_To_Be_Added || "0") - Number(rowData.totalAdded || "0")) > 0) ? "red" : "green" }}>{((Number(rowData.no_Of_Timesheets_To_Be_Added || "0") - Number(rowData.totalAdded || "0")) > 0) ? "Pending" : "All Uploaded"}</p>} />

        {/* <Column field="addedByConsultant" header="No of Timesheet Added By Consultant" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} body={(rowData: any, options: any) => <p className={(rowData.addedByConsultant > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "addedByConsultantList", index: options.rowIndex })}>{rowData.addedByConsultant}|<span style={{ color: "red" }}>{rowData.total_Consultant_Added_By_Consultant}</span></p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedByConsultant || 0), 0);
          const consultantCount2 = tableData.tableData.reduce((sum, item) => sum + (item.total_Consultant_Added_By_Consultant || 0), 0);
          return <span className="font-bold">{consultantCount}|<span style={{ color: "red" }}>{consultantCount2}</span></span>;
        }} />
        <Column field="addedBySubVendor" header="No of Timesheet Added By SubVendor" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} body={(rowData: any, options: any) => <p className={(rowData.addedBySubVendor > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "addedBySubVendorList", index: options.rowIndex })}>{rowData.addedBySubVendor}|<span style={{ color: "red" }}>{rowData.total_Consultant_Added_By_SubVendor}</span></p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedBySubVendor || 0), 0);
          const consultantCount2 = tableData.tableData.reduce((sum, item) => sum + (item.total_Consultant_Added_By_SubVendor || 0), 0);
          return <span className="font-bold">{consultantCount}|<span style={{ color: "red" }}>{consultantCount2}</span></span>;
        }} />
        <Column field="addedByInHouse" header="No of Timesheet Added By Inhouse" headerStyle={{ whiteSpace: "normal", minWidth: "100px" }} body={(rowData: any, options: any) => <p className={(rowData.addedByInHouse > 0) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => setOpenSubModel({ open: true, name: "addedByInHouseList", index: options.rowIndex })}>{rowData.addedByInHouse}|<span style={{ color: "red" }}>{rowData.total_Consultant_Added_By_InHouse}</span></p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.addedByInHouse || 0), 0);
          const consultantCount2 = tableData.tableData.reduce((sum, item) => sum + (item.total_Consultant_Added_By_InHouse || 0), 0);
          return <span className="font-bold">{consultantCount}|<span style={{ color: "red" }}>{consultantCount2}</span></span>;
        }} /> */}
      </DataTable>
      <Dialog visible={openSubModel.open} style={{ width: '80vw' }} header={<p>Sub Table</p>} modal className="p-fluid" onHide={() => {
        setOpenSubModel({ open: false, name: "", company: 0, pO_IDs: "" });
        setSubTableData({ tableData: [], loading: false });
      }}>
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          resizableColumns
          showGridlines
          columnResizeMode="expand"
          exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
          size="small"
          stripedRows
          scrollable
          scrollHeight="70vh"
          value={subTableData.tableData}
          loading={subTableData.loading}
        >
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="consultant_Name" header="Consultant Name" />
          <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat, true)} />
          <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat, true)} />
          <Column field="workHours" header="Work Hours" body={(rowData: any) => <p>{Number(rowData.workHours || "0") + Number(rowData.overlapWorkHours || "0")}</p>} />
          <Column field="status" header="Status" body={r => r.status ? VerifyStatus[r.status] : ''} />
        </DataTable>
      </Dialog>
      <Toast ref={toast} />
    </>
  );
};

export default TimesheetReportUS;
